import { Component  } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-contabilidad',
  templateUrl: './contabilidad.component.html',
  styleUrls: ['./contabilidad.component.scss']
})
export class ContabilidadComponent   {

  constructor(private loginService: LoginService) { }

  clickGuard() {
    this.loginService.clickGuard = true;
  }
}
  